import {Requests, defaultErrorHandler} from './base'


function activitiesRequest ($parent) {
  return Requests.get('/account/activities')
    .then(response => {
      $parent.loading.isActive = false
      return response.data
    })
    .catch(error => {
      return defaultErrorHandler(error, $parent)
    })
    .finally(() => {
      $parent.loading.isActive = false
    })
}


export {activitiesRequest}



// WEBPACK FOOTER //
// ./src/modules/request/account.js